import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { canUseDOM } from 'exenv';
import cx from 'classnames';

import Brand from 'models/brand';

import { PAGEVIEW_EVENT } from 'lib/analytics/events/index';
import { PASSWORD_RECOVERY_APP } from 'lib/app-names';
import { pageProps, urlProps } from 'lib/analytics/page-properties';
import { routerLocationShape } from 'lib/common/prop-types';

import trackEventCreator from 'action-creators/analytics/track-event';
import recoverPassword from 'action-creators/account/recover-password';
import cleanupPasswordRecoveryState from 'action-creators/account/cleanup-password-recovery-state';
import addErrors from 'action-creators/account/add-errors';
import dismissError from 'action-creators/account/dismiss-error';
import addMessage from 'action-creators/messaging/add-message';

import PasswordRecoveryForm from 'components/account/password-recovery-form';

const propTypes = {
  brand: PropTypes.instanceOf(Brand).isRequired,
  trackEvent: PropTypes.func.isRequired,
  recoverPassword: PropTypes.func.isRequired,
  routerLocation: routerLocationShape.isRequired,
};

class SignIn extends Component {
  componentWillMount() {
    if (canUseDOM) {
      const pageProperties = pageProps({ app: PASSWORD_RECOVERY_APP });
      this.props.trackEvent({
        ...PAGEVIEW_EVENT,
        ...pageProperties,
        name: pageProperties.pageName,
        properties: urlProps(),
      });
    }
  }

  render() {
    const { brand } = this.props;
    const containerClasses = cx({
      'background-blue-gradient': !brand.isBestParking,
      'background-color-bp-dark-blue': brand.isBestParking,
      'padding-vertical-80': true,
      'text-color-dark-slate': true,
      'force-full-height': true,
    });

    return (
      <div className={containerClasses}>
        <div className="container margin-bottom-120">
          <div className="row">
            <div className="padding-top-60 padding-bottom-80 col-gutter-sm-80 heavy-shadowed rounded-corners col-sm-8 col-xs-10 col-sm-offset-2 col-xs-offset-1 background-white">
              <PasswordRecoveryForm {...this.props} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

SignIn.propTypes = propTypes;

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    trackEvent: trackEventCreator,
    recoverPassword,
    cleanupPasswordRecoveryState,
    dismissError,
    setErrors: addErrors,
    addMessage,
  }, dispatch)
);

const mapStateToProps = (state, ownProps) => {
  const { brand } = state.brand;
  const { appContext } = state.app;
  const { errors } = state.account;

  let { location: routerLocation } = state.router;
  if (!routerLocation) {
    ({ routerLocation } = ownProps);
  }

  return { routerLocation, brand, appContext, errors };
};

export default connect(mapStateToProps, mapDispatchToProps)(SignIn);
